<template>
  <div>
    <div v-if="!hasDropdown()" :class="getImageIconClass()">
      <b-img :src="getAvatarIcon()" :class="getWhiteCircle()" :style="getWhiteCircleStyle()" :width="width" height="auto" alt=""></b-img>
    </div>
    <div>
      <div v-if="hasDropdown()">
        <!-- <button v-on:click="onAvatarButtonClicked()" :id="getAvatarButtonId()" :class="getImageIconClass()" :aria-controls="getAvatarCollapseId()">
          <b-img :src="getAvatarIcon()" :id="getAvatarImageId()" :class="getWhiteCircle()" :style="getWhiteCircleStyle()" :width="width" height="auto" :alt="altAvatar"></b-img>
        </button> -->
        <b-button v-b-toggle="getAvatarCollapseId()" :id="getAvatarButtonId()" :class="getImageIconClass()" aria-label="menu secondaire">
          <b-img :src="getAvatarIcon()" :id="getAvatarImageId()" :class="getWhiteCircle()" :style="getWhiteCircleStyle()" :width="width" height="auto" :alt="altAvatar"></b-img>
        </b-button>
      </div>
      <div v-if="hasDropdown()" class="row dropdown-container" ref="avatarDropdownMenuRef">
        <div class="col-sm-2 profile-dropdown" :style="getDropdownCenteringStyle()" v-show="profilePanelOpen">
          <br aria-hidden="true"/>
          <b-collapse :id="getAvatarCollapseId()" v-model="profilePanelOpen">
            <div v-if="isLoggedIn()" class="user-name">
              {{ getUserName() }}
            </div>
            <br  aria-hidden="true"/>
            <button class="btn btn-primary centered-element profile-button" href="#" v-on:click="onDeleteProfileButtonClicked()">{{ LG("HP_deleteProfileText") }}</button>
            <br  aria-hidden="true"/>
            <!--<button class="btn btn-primary centered-element profile-button" href="#" v-on:click="onToggleUIButtonClicked()">{{getNewUIButtonLabel()}}</button>
                        <br />-->
          </b-collapse>
          <br  aria-hidden="true"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AvatarIcon",
  props: {
    width: {
      type: String,
      default: "60",
    },
    dropdown: {
      type: String,
      default: "no",
    },
    id: {
      type: String,
      default: "avataricon-id",
    },
  },
  data() {
    return {
      // Arrays
      avatars: [
        {
          image: require("@/assets/avatars/user.png"), // Default icon before one is selected
        },
        {
          image: require("@/assets/avatars/avatar01.png"),
        },
        {
          image: require("@/assets/avatars/avatar02.png"),
        },
        {
          image: require("@/assets/avatars/avatar03.png"),
        },
        {
          image: require("@/assets/avatars/avatar04.png"),
        },
      ],

      // Text
      altAvatar: "icône d'avatar",

      // Images

      // Variables
      profilePanelOpen: false,
    };
  },
  mounted() {},
  computed: {},
  methods: {
    getAvatarCollapseId() {
      return this.id + "-collapseAv";
    },
    getAvatarButtonId() {
      return this.id + "-avatarButton";
    },
    getAvatarImageId() {
      return this.id + "-avatarImage";
    },
    getImageIconClass() {
      if (this.profilePanelOpen) {
        return "image-icon-panel-open";
      }

      return "image-icon";
    },
    getWhiteCircle() {
      if (this.newVersion()) {
        // Remove rollover if not clickable
        if (!this.hasDropdown()) {
          return "white-circle-new-not-clickable";
        }

        return "white-circle-new";
      }
      return "white-circle";
    },
    documentClick(e) {
      var buttonId = this.getAvatarButtonId();
      var buttonElement = document.getElementById(buttonId);
      var avatarImageId = this.getAvatarImageId();
      var imageElement = document.getElementById(avatarImageId);
      var clickedElement = e.target;

      //console.log("CLICKED: " + clickedElement.tagName);

      if (clickedElement == buttonElement || clickedElement == imageElement) {
        //console.log("ignore focus check for avatar button");
        return;
      }

      // When the page is clicked on, if clicking outside this element, close the panel
      var dropDownRef = this.$refs.avatarDropdownMenuRef;
      if (dropDownRef != null) {
        if (dropDownRef != clickedElement) {
          if (!dropDownRef.contains(e.target)) {
            //console.log("Not contained! closing panel");
            this.profilePanelOpen = false;
          }
        }
      }
    },
    getNewUIButtonLabel() {
      if (this.newVersion()) {
        return this.LG("LO_OldUIButton");
      } else {
        return this.LG("LO_NewUIButton");
      }
    },
    onToggleUIButtonClicked() {
      if (this.newVersion()) {
        this.enableOldVersion();
      } else {
        this.enableNewVersion();
      }

      // Close the panel
      this.onAvatarButtonClicked();
    },
    getUserName() {
      var fullName = "";
      if (this.$store.state.user != null) {
        fullName = this.$store.state.user.firstName + " " + this.$store.state.user.lastName;
      }
      return fullName;
    },
    isLoggedIn() {
      return this.$store.state.loggedin;
    },
    onAvatarButtonClicked() {
      this.profilePanelOpen = !this.profilePanelOpen;
    },
    hasDropdown() {
      // Before user has selected an avatar, don't supply a dropdown
      // TBD we need the dropdown for the cheat for now!


      // No need for a dropdown to change the avatar when we are in that menu
      if (this.$route.name == "avatar") {
        return false;
      }

      if (this.dropdown == "yes") {
        return true;
      }
      return false;
    },

    getDropdownCenteringStyle() {
      // Home page we need to shift left since we are at right side of screen
      if (this.$route.name == "home") {
        // return "left: -80px;";
        return "left: -10px;";
      } else {
        return "left: -10px;";
      }
    },
    getWhiteCircleStyle() {
      var circleWidth = Number(this.width) + 5;
      return "height: " + circleWidth + "px;  width: " + circleWidth + "px;";
    },
    getAvatarIcon() {
      var index = 0;

      var avatarIcon = this.avatars[index].image;
      return avatarIcon;
    },
    onDeleteProfileButtonClicked() {
      this.$store.commit("resetGameState");
      this.saveGameState();
      this.loadFromLocalStorage();
      this.profilePanelOpen = false;
      this.$router.push("/");
    },

  },
  created() {
    document.addEventListener("mousedown", this.documentClick);
  },
  destroyed() {
    document.removeEventListener("mousedown", this.documentClick);
  },
};
</script>

<style scoped>
::v-deep .btn-secondary:focus {
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
#avataricon-id-avatarButton {
  padding: 0 !important;
}
.white-circle {
  background-color: white !important;
  border-radius: 50%;
}

.white-circle:hover,
button:focus .white-circle {
  background-color: #c8d9e0 !important;
}

.white-circle-new {
  background-color: white !important;
  border-radius: 50%;
  box-shadow: 0px 6px 7px #00000029;
  border: 4px solid #07415b;
}

.white-circle-new:hover,
button:focus .white-circle-new {
  background-color: #c8d9e0 !important;
}

.white-circle-new-not-clickable {
  background-color: white !important;
  border-radius: 50%;
  box-shadow: 0px 6px 7px #00000029;
  border: 4px solid #07415b;
}

.dropdown-container {
  position: relative;
  top: 0px;
  left: 0px;
}

.profile-dropdown {
  position: absolute;
  top: 3px;
  background-color: white;
  border: 1px solid #c3b8c5;
  color: black;
  margin-top: -2px;
  min-width: 150px;
  z-index: 1;
}

.profile-button {
  font-size: 12px !important;
  color: white !important;
  background-color: #3f5d12 !important;
}

.user-name {
  color: black;
}

.image-icon-panel-open {
  background-color: transparent !important;
  border: none;
}
.image-icon-panel-open:focus {
  outline: none !important;
}

.image-icon {
  background-color: transparent !important;
  border: none;
}
.image-icon:focus {
  /* outline: none !important; */
  border-radius: 50%;
  /* box-shadow: 0px 6px 7px #00000029; */
}
</style>
